<template>
  <div
    ref="kt_modal_produto_peso_item"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_produto_peso_item"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/communication/com003.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">Peso</h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-5">
          <div class="row">
            <div class="col-md-6 fv-row mb-4">
              <label class="form-label">Peso Bruto</label>
              <CurrencyInput
                id="txtPesoBruto"
                class="form-control mb-2"
                placeholder="Peso Bruto"
                style="text-align: right"
                v-model="this.pesoBruto"
                :options="options"
                @keydown.stop.prevent.enter="nextFocus(`txtPesoLiquido`)"
              ></CurrencyInput>
            </div>
            <div class="col-md-6 fv-row mb-4">
              <label class="form-label">Peso Líquido</label>
              <CurrencyInput
                id="txtPesoLiquido"
                class="form-control mb-2"
                placeholder="Peso Líquido"
                style="text-align: right"
                v-model="this.pesoLiquido"
                :options="options"
                @keydown.stop.prevent.enter="nextFocus(`btnConfirmar`)"
              ></CurrencyInput>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger svg-icon-white me-2 mb-2"
            data-bs-dismiss="modal"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            type="button"
            id="btnConfirmar"
            class="btn btn-success svg-icon-white mb-2"
            data-bs-dismiss="modal"
            @click="confirmar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import CurrencyInput from "@/components/text/CurrencyInput";

export default {
  components: { CurrencyInput },
  emits: ["exibirModalPesoProduto", "confirmarPesoProduto"],
  props: {
    pesoBrutoItem: { type: Number, required: true },
    pesoLiquidoItem: { type: Number, required: true },
  },
  methods: {
    async confirmar() {
      this.$emit("confirmarPesoProduto", this.pesoBruto, this.pesoLiquido);
    },
    cancelar() {
      hideModal(this.$refs.kt_modal_produto_peso_item);
      this.$emit("exibirModalPesoProduto", false);
    },
  },
  mounted() {
    this.pesoBruto = this.pesoBrutoItem;
    this.pesoLiquido = this.pesoLiquidoItem;
    this.$utils.requestFocus("txtPesoBruto");
  },
  data() {
    return {
      pesoBruto: 0,
      pesoLiquido: 0,
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: true,
      },
    };
  },
};
</script>

<style>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  background-color: #00000042;
}
</style>
